<template>
  <div>
    <second-nav></second-nav>
  </div>
</template>

<script>
  import SecondNav from "components/content/secondnav/SecondNav";
  export default {
    name: "index",
    components:{
      SecondNav
    }
  }
</script>
